import * as React from 'react';
import SwaggerUIConstructor from 'swagger-ui';
import { SwaggerConfigs, SwaggerRequest, SwaggerResponse } from 'swagger-ui-dist';
import 'swagger-ui-react/swagger-ui.css';

export type System = any;
export type Selector = any;
export type State = any;

export type RequestInterceptorType = (req: SwaggerRequest) => Promise<SwaggerRequest>;
export type ResponseInterceptorType = (req: SwaggerResponse) => Promise<SwaggerResponse>;

interface SwaggerComponentProps extends Omit<SwaggerConfigs, 'requestInterceptor' | 'responseInterceptor'> {
  requestInterceptor: RequestInterceptorType;
  responseInterceptor: ResponseInterceptorType;
  isGrpc?: boolean;
  oauth2RedirectUrl: any;
}

export function SwaggerComponent(props: SwaggerComponentProps) {
  // This ref is just a safeguard to make sure the dom is fully finished rendering
  //   before we insert. It should *not* be necessary, but it also isn't really hurting
  //   anything and we've had a bug that touches near this concept.
  let displayRef = React.useRef(null);

  // The sanitized dom_id, where all periods are replaced with dashes. This fixes issues where Swagger tries
  //   doing a `querySelector` which fails, due to it treating the period as a class selector, and not part of the ID itself.
  const [sanitizedDomId, setSanitizedDomId] = React.useState<string>('')
  React.useEffect(() => {
    setSanitizedDomId(props.dom_id?.split('.').join('-'))
  }, [props.dom_id])

  React.useEffect(() => {
    if (!!displayRef.current) {
      SwaggerUIConstructor({
        spec: props.spec,
        plugins: [props.plugins],
        dom_id: `#display-swagger-${sanitizedDomId}`, // This should be the std '#' + the id below
        withCredentials: true,
        deepLinking: true,
        showMutatedRequest: props.isGrpc,
        oauth2RedirectUrl: props.oauth2RedirectUrl,
        requestInterceptor: props.requestInterceptor,
        responseInterceptor: props.responseInterceptor,
        syntaxHighlight: { activated: false }
      });
    }
  }, [props.dom_id, displayRef.current]);

  return <div id={`display-swagger-${sanitizedDomId}`} ref={displayRef as any} />;
}
